import { MI_Container, MI_Header, MI_Name, MI_Shadow, moduleItemVariants } from "./ModuleItem.styled";
import { ServiceName } from "../../../../../../../constants";
import { GrandChartModuleStore } from "../../../../../../../stores/grand-charts/grand-chart-module.store";

interface ModuleItemProps {
	isActive: boolean;
	service: ServiceName;
	grandChartModule: GrandChartModuleStore;
}

export const ModuleItem = ({ isActive, service, grandChartModule }: ModuleItemProps) => {
	return (
		<MI_Shadow variants={moduleItemVariants}>
			<MI_Container $isActive={isActive} $service={service}>
				<MI_Header>Module {grandChartModule.sort}</MI_Header>
				<MI_Name>{grandChartModule.module.name}</MI_Name>
			</MI_Container>
		</MI_Shadow>
	);
};
